module.exports = __webpack_public_path__ + "img/dstv-login-3.9d01aeb6.jpg";